import React, { Component } from 'react';
import styles from './styles.module.scss';
import { NavLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

class ErrorBoundary extends Component {
  
  constructor(props) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box className={styles.wrapper}>
          <Box className={styles.header}>
            <NavLink
              to='/'
              style={{ display: 'block' }}
              onClick={() => this.setState({ hasError: false })}
            >
              <img src='/logo.ico' alt='logo' className={styles.logo} />
            </NavLink>
          </Box>
          <Box className={styles.body}>
            <Typography variant='h1'>Ой, что-то пошло не так!</Typography>
            <Button
              type='button'
              className={styles.button}
              onClick={() => this.setState({ hasError: false })}
            >
              Try again
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
